import KyMethod from "@repositories/KyMethod"

interface ShareLinkBody {
  alias?: string
  type: "direct"
  password?: null
  active: true
  expires_at?: Date
  activates_at?: Date
  utm?: string
  domain_id?: null
  title?: string
  description?: string
  pixels?: any[]
  groups?: any[]
  rules?: any[]
  long_url: string
}

export default class MiscRepositories extends KyMethod {
  protected async getRawTestimonials() {
    return this._getData("/testimonials?type=career")
  }

  protected async getRawFAQs() {
    return this._getData("/faqs?type=career")
  }

  async getRawUniversities() {
    return this._getData("/universities")
  }

  protected async getRawShareLink(body: ShareLinkBody) {
    return this._protectedExternalCrudMethod("https://harisenin.link/api/v1/link", {
      body,
      method: "post",
      token: process.env.HARISENIN_LINK_TOKEN || process.env.LINK_TOKEN || "",
    })
  }
}
